export default __webpack_public_path__ + "static/media/proof2.93c6fb4f.jpg";